module.exports = ".categoria-gasto {\n  cursor: -webkit-grab;\n  cursor: grab; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/gastos/gastos-categoria/gastos-categoria.component.scss
// module id = ./src/app/gastos/gastos-categoria/gastos-categoria.component.scss
// module chunks = main